<template>
  <div class="is-main-content">
    <div class="columns">
      <div class="column ">
        <div>
          <div class="container is-fluid">
            <div class="columns">
              <div class="column is-9-fullhd is-7-desktop is-6-tablet">
                <div class="content">
                  <h3 class="level"> {{title}} </h3>
                </div>
              </div>
            </div>
          </div>
          <hr>
          <br>
          <div class="container is-fluid">
            <b-message title="Connecter vous d'abord sur Affixe1" type="is-primary"
              :closable="false">
              Pensez à vous connecter d'abord sur Affixe1 dans un autre onglet de
              votre navigateur pour pouvoir accéder directement à la page concernée
              et effectuer la modification.
            </b-message>
            <div class="level">
              <div class="level-left">
                <div class="field has-addons">
                  <p class="control">
                    <b-button
                      :type="isListNoGoe ? 'is-primary' : ''"
                      @click="isListNoGoe = !isListNoGoe">
                      Non géolocalisé
                    </b-button>
                  </p>
                  <p class="control">
                    <b-button
                      :type="!isListNoGoe ? 'is-primary' : ''"
                      @click="isListNoGoe = !isListNoGoe">
                      Sans photo
                    </b-button>
                  </p>
                </div>
              </div>
              <div class="level-right">
                <app-export-excel :liste="dataListe"/>
              </div>
            </div>
          </div>
          <br>
          <div class="container is-fluid">
            <table-list :isListNoGoe="isListNoGoe" :dataList="panneauxNoGeo" v-if="isListNoGoe"/>
            <table-list :isListNoGoe="isListNoGoe" :dataList="facesNoAttach" v-else/>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { createNamespacedHelpers } from 'vuex';
import ExportExcel from '@/components/creationOpportunite/exportExcel';
import TableList from './tableauPanneaux';

const VenteFacesLc = createNamespacedHelpers('venteFacesLc');

export default {
  components: {
    TableList,
    appExportExcel: ExportExcel,
  },
  data() {
    return {
      isListNoGoe: true,
    };
  },
  computed: {
    ...VenteFacesLc.mapGetters({
      panneauxNoGeo: 'panneauNoGeo',
      panneauxNoAttach: 'panneauxNoAttach',
    }),
    dataListe() {
      if (this.isListNoGoe) return { type: 'panneauxNoGeo', data: this.panneauxNoGeo };
      return { type: 'panneauxNoAttach', data: this.panneauxNoAttach };
    },
    title() {
      if (this.isListNoGoe) return 'Liste des panneaux non géolocalisés';
      return 'Liste des faces sans photo';
    },
    facesNoAttach() {
      const faces = [];
      const data = this.panneauxNoAttach;
      data.forEach(pan => {
        pan.faces.forEach(face => {
          faces.push({
            ...pan,
            faces: [face],
          });
        });
      });
      return faces;
    },
  },
  methods: {
    ...VenteFacesLc.mapActions({
      getPanneauxNoGeoNoAttach: 'getPanneauxNoGeoNoAttach',
    }),
  },
  async mounted() {
    if (this.$route.params.type === 'noGoe') this.isListNoGoe = true;
    if (this.$route.params.type === 'noPhoto') this.isListNoGoe = false;
    if (!this.panneauxNoGeo.length && !this.panneauxNoGeo.length) {
      const loadingComponent = this.$buefy.loading.open({ container: null });
      try {
        await this.getPanneauxNoGeoNoAttach();
        loadingComponent.close();
      } catch (error) {
        loadingComponent.close();
      }
    }
  },
};
</script>

<style>

</style>



// WEBPACK FOOTER //
// src/components/panneaux/index.vue